<template>
  <div class="historico appnavbar-body">
    <div class="chat-history px-1 pb-1">
      <!--
      <div class="d-flex justify-content-center">
        <div
          v-if="stateLocal.isloading"
          class="spinner-border spinner-border-sm "
          role="status"
        ></div>
      </div>
      -->
      
      <div class="row">
        <div class="col-md-12">
          <chat-history-item
            v-for="(c, i) in stateLocal.chats"
            :key="i"
            :chatItem="c"
            @click="showMessages(c)"
          />
        </div>
        </div>
      <!-- Modal -->
      <modal
        v-if="stateLocal.showModalChatHistoryMessages"
        :title="tm('chatHistorico')"
        @closeModal="stateLocal.showModalChatHistoryMessages = false"
      >
        <template v-slot:body>
          <chat-history-messages :messages="stateLocal.chatMessages" />
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { reactive } from "@vue/reactivity";
import Datepicker from "vue3-datepicker";
import { pt } from "date-fns/locale";
import ChatHistoryItem from "./chathistoryitem.vue";
import ChatHistoryMessages from "./chathistorymessages.vue";
import Modal from "../../components/Modal";
import differenceInDays from "date-fns/differenceInDays";
import ChatService from "../../services/ChatService";
import HsmService from "../../services/HsmService";
import { onMounted } from "@vue/runtime-core";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";

const toast = useToast();
export default {
  name: "HistoricoHsm",
  components: { Datepicker, ChatHistoryItem, ChatHistoryMessages, Modal },
  setup() {
    let intervalo = null;


    const { tm, locale } = useI18n();
    const store = useStore();
    const limitDays = 90;
    const campanhaSelect = ref("");
    const fluxoSelect = ref("");
    const dataSelect = reactive({
      dataInicio: ref(new Date().addDays(-limitDays)),
      dataFinal: ref(new Date()),
    });
    const stateLocal = reactive({
      chatMessages: [],
      chats: [],
      buttonControl: false,
      isloading: false,
      showModalChatHistoryMessages: false,
      campanhas: [],
      fluxos: [],
      valorOriginal: [],
    });

    const langData = computed(() => {
      switch (locale.value) {
        case "en":
          return enUS;
        case "es":
          return es;
        case "pt":
          return pt;
        default:
          return pt;
      }
    });

    onMounted(() => {
      
       carregarDadosChats(); // executa logo de cara
      intervalo = setInterval(() => {
        carregarDadosChats();
      }, 100000); // 10 segundos


    });
    //METODOS

    function resetInfo() {
      dataSelect.dataInicio = new Date().addDays(-limitDays);
      dataSelect.dataFinal = new Date();
      stateLocal.chats = [];
    }

    async function showMessages(chatItem) {
      let response = await ChatService.GetLastHsmMessageByAgentId(
        chatItem.destinatario,
        store.state.usuario.id
      );
      console.log("response:", response.data);

      try {
        response.data[0].timestamp = chatItem.dataInclusao;
        response.data[0].firstAgentResponse = chatItem.dataRecebido;
        
      } catch (error) {
        console.log("Erro ao tentar atribuir firstAgentResponse:", error);
      }

      console.log("response2:", response.data);

      stateLocal.chatMessages = response.data;
      stateLocal.showModalChatHistoryMessages = true;
    }

   

    async function carregarDadosChats() {
      // checar se os dados do cliente já estão carregados
      stateLocal.isloading = true;
      
      try {
       
        let response = await HsmService.BuscarHsmEnviadosPeloUsuario24Horas(
          store.state.usuario.id
        );

        for (const item of response.data) {
          let repMensagemSalva = await ChatService.GetHSM(item.mensagemsalvaId);
          item.mensagem = repMensagemSalva.data.titulo || 'Título não encontrado';
          
        }

        stateLocal.chats = response.data;
        stateLocal.valorOriginal = response.data;
        
      } catch (e) {
        console.log("Historico", e);
      } finally {
        stateLocal.isloading = false;
      }
    }

    return {
      onMounted,
      stateLocal,
      pt,
      carregarDadosChats,
      dataSelect,
      resetInfo,
      showMessages,
      tm,
      langData,
      campanhaSelect,
      fluxoSelect,
    };
  },
 
};
</script>

<style scoped>
.spinner-border-sm {
  align-content: center;
}

.main-new {
  height: 92vh;
}

.vf-20 {
  width: 30vh !important;
}

[class*="col-"] {
  float: left;
  padding: 5px;
}

.spinner-border-sm {
  width: 3rem;
  height: 3rem;
  border-width: 0.4em;
}

.vf-20 {
  width: 20vh !important;
}

.input-group {
  width: 100% !important;
}

.tamanho {
  width: 50% !important;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  [class*="col-"] {
    width: 100%;
  }

  .vw-60 {
    width: 50vw !important;
  }
}
</style>
